<div class="loading" [ngClass]="{'show' : (showObservable$ | async)}">
  <div class="loading-overlay"></div>
  <div class="loading-content"></div>
</div>
